module.exports = __webpack_public_path__ + "img/car_rest.28a72d16.svg";